import React from 'react'
import PropTypes from 'prop-types'

import { has, get } from 'lodash'

import { users } from '../redux'

import Avatar from '../components/Avatar'

import './UserDisplay.css'

const UserDisplay = ({ user, withAvatar }) => (
    <div className="user-avatar">
        { withAvatar && <Avatar user={ user } /> }
        <div className="user-details">
            { <strong>{ users.fullName(user) }</strong> }
            { has(user, 'email') && <span>{ user.email }</span> }
            { get(user, 'is_deleted') ? <span>(deleted)</span> : (has(user, 'phone') && <span>{ user.phone }</span>) }
        </div>
    </div>
)

UserDisplay.propTypes = {
    user       : PropTypes.object,
    withAvatar : PropTypes.bool
}

UserDisplay.defaultProps = {
    withAvatar: true
}

export default UserDisplay
